
import { CacheService } from '../services/cache.service';
import { CacheKey } from '../constants/cachekey.constants';
import { Member } from '../interfaces/member.interface';
import { ContactPreferenceType } from '../enums/contact-preference-type.enum';
import { CommunicationPreferenceValues } from '../enums/communication-preference-value.enum';
import { DiscountTypeConstants } from '../constants/discount-type.constants';
import { CommonService } from '../services/common.service';
import { Output, EventEmitter, Input, Component, OnInit } from '@angular/core';

@Component({
       selector: 'app-my-retail-site,[app-my-retail-site]',
    templateUrl: '../templates/template1/views/app-my-retail-site.component.html',
    styleUrls: [
        '../templates/template1/themes/default/less/app-my-retail-site.less'
    ]
})
export class AppMyRetailSiteComponent implements OnInit {
    // tslint:disable-next-line:no-input-rename
    @Input() show;
    @Input() memberInformation: Member;
    @Input() isHamburgerMenu;
    @Output() removeShareFBO = new EventEmitter();
    countryCode: string;
    languageCode: string;
    showMenu = false;
    userInfo: Member;
    shareFBOID: string;
    showMyRetailSiteEmail = false;
    showMyRetailSitePhone = false;
    showMyRetailMemberPromotions: boolean;
    discountType: string;
    phoneNumberFormat:string;
    constructor(
        private _cacheService: CacheService,
        private _commonService: CommonService) {
        this.countryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
        this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    }
    ngOnInit() {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.shareFBOID = this._cacheService.getSessionValue(CacheKey.fboId);
        const memberSalePromotionModel = this._cacheService.getSessionValue(CacheKey.MemberSalePromotionModel) ?
        JSON.parse(this._cacheService.getSessionValue(CacheKey.MemberSalePromotionModel)) : null;
        this.phoneNumberFormat = this._commonService
        .getPhoneNumberFormatByCountryCode(this.countryCode);
        if (memberSalePromotionModel) {
            this.showMyRetailMemberPromotions = true;
            this.discountType = memberSalePromotionModel.discountConfigType || '';
        }
        if (this.memberInformation && this.memberInformation.memberPreferences
            && this.memberInformation.memberPreferences.length > 0) {
            this.displayDataBasedOnMemberPreferences();
        } else {
            if (this.memberInformation.phone) {
                this.showMyRetailSitePhone = true;
            }
            if (this.memberInformation.email) {
                this.showMyRetailSiteEmail = true;
            }
        }
    }

    /**
   * @description Remove share fbo details
   * @memberof AppHeaderComponent
   */
    exitMyRetailSite(): void {
        this._cacheService.removeSessionValue(CacheKey.fboId);
        this._cacheService.remove(CacheKey.ShareFBODetails);
        this.show = false;
        this.isHamburgerMenu = false;
        window.history.pushState(null, null, window.location.pathname);
        this.removeShareFBO.emit();
    }

    /**
  * Display data based on member preferences
  *
  * @memberof AppHeaderComponent
  */
    displayDataBasedOnMemberPreferences(): void {
        const emailPreferences = this.memberInformation.memberPreferences
            .find(item => ((Number(item.preferenceId) === ContactPreferenceType.MyRetailSiteEmail)
                && (Number(item.preferenceValue) === CommunicationPreferenceValues.yes)));
        if (emailPreferences) {
            this.showMyRetailSiteEmail = true;
        }
        const phonePreferences = this.memberInformation.memberPreferences
            .find(item => (Number(item.preferenceId) === ContactPreferenceType.MyretailSitePhone)
                && (Number(item.preferenceValue) === CommunicationPreferenceValues.yes));
        if (phonePreferences) {
            this.showMyRetailSitePhone = true;
        }
    }
}
